import { useState } from "react";
import { useControllerContext } from "../../../../hooks/controller-context";
import { TimerControllerInputBox } from "../../../../style";
import { ControllerTournamentTimeButtonWrapper } from "../../../tournament-info/style";
import {} from "../../style";
import {
  MobileTimerControllerClockWrapper,
  MobileControllerBackgroundBox,
  MobileControllerInputWrapper,
  MobileControllerClockTimeWrapper,
  MobileControllerClockTimeWrapperButton,
  MobileControllerClockTimeButtonWrapper,
  MobileControllerClockTimeTextWrapper,
} from "./style";
import { useTournamentLevel } from "../../../tournament-info/hooks/use-tournament-level";
import { useTournamentTimer } from "../../../tournament-info/hooks/use-tournament-timer";
import { useTournamentUser } from "../../../sit-in/hooks/use-tournament-user";

const MobileTimerControllerClock = () => {
  // 레벨 이동 관련
  const { handleFirstLevel, handleLastLevel, handleUpdateLevel, getLevelText } =
    useTournamentLevel();

  // 시간 이동 관련
  const { handleUpdateTime } = useTournamentTimer();

  // 플레이어 조정
  const {
    userCountInput,
    setUserCountInput,
    handleUpdateUserCount,
    handleInputUserCount,
  } = useTournamentUser();

  const { updateTotalStack, timeInfo } = useControllerContext();
  const [totalStackInput, setTotalStackInput] = useState(0);

  return (
    <MobileTimerControllerClockWrapper>
      <MobileControllerBackgroundBox>
        <MobileControllerClockTimeWrapper>
          <MobileControllerClockTimeButtonWrapper>
            <MobileControllerClockTimeWrapperButton>
              <div
                className="button"
                onClick={() => {
                  handleUpdateTime(0, true);
                }}
              >
                <img src="/image-web/controller/stop.svg" alt="stop" />
              </div>
              <div className="name">정지</div>
            </MobileControllerClockTimeWrapperButton>
            <ControllerTournamentTimeButtonWrapper isPlus={true} isWide={false}>
              <div className="second-box box">
                <div className="button" onClick={() => handleUpdateTime(-1000)}>
                  +1초
                </div>
              </div>
              <div className="minute-box box">
                <div
                  className="button"
                  onClick={() => handleUpdateTime(-60000)}
                >
                  +1분
                </div>
              </div>
            </ControllerTournamentTimeButtonWrapper>
          </MobileControllerClockTimeButtonWrapper>
          <MobileControllerClockTimeTextWrapper>
            <div className="title">
              {timeInfo.elapsedTimeMs && timeInfo.elapsedTimeMs > 0
                ? "현재 레벨 남은 시간 조정"
                : "시작까지 남은 시간"}
            </div>
            <div className="time">{timeInfo.remainingTimeInCurrentLevel}</div>
          </MobileControllerClockTimeTextWrapper>
          <MobileControllerClockTimeButtonWrapper>
            <MobileControllerClockTimeWrapperButton>
              <div
                className="button"
                onClick={() => {
                  handleUpdateTime(0, false);
                }}
              >
                <img src="/image-web/controller/start.svg" alt="start" />
              </div>
              <div className="name">재생</div>
            </MobileControllerClockTimeWrapperButton>
            <ControllerTournamentTimeButtonWrapper
              isPlus={false}
              isWide={false}
            >
              <div className="second-box box">
                <div className="button" onClick={() => handleUpdateTime(1000)}>
                  -1초
                </div>
              </div>
              <div className="minute-box box">
                <div className="button" onClick={() => handleUpdateTime(60000)}>
                  -1분
                </div>
              </div>
            </ControllerTournamentTimeButtonWrapper>
          </MobileControllerClockTimeButtonWrapper>
        </MobileControllerClockTimeWrapper>
      </MobileControllerBackgroundBox>
      <MobileControllerBackgroundBox>
        <div className="title">레벨 이동</div>
        <MobileControllerInputWrapper>
          <img
            src="/image-web/controller/first.svg"
            alt="first"
            onClick={handleFirstLevel}
          />
          <img
            src="/image-web/controller/minus.svg"
            alt="minus"
            onClick={() => handleUpdateLevel(-1)}
          />
          <div className="level">{getLevelText()}</div>
          <img
            src="/image-web/controller/plus.svg"
            alt="plus"
            onClick={() => handleUpdateLevel(1)}
          />
          <img
            src="/image-web/controller/last.svg"
            alt="last"
            onClick={handleLastLevel}
          />
        </MobileControllerInputWrapper>
      </MobileControllerBackgroundBox>
      <MobileControllerBackgroundBox>
        <div className="title">TOTAL STACK 조정</div>
        <MobileControllerInputWrapper>
          <img
            src="/image-web/controller/minus.svg"
            alt="minus"
            onClick={() => {
              updateTotalStack(-totalStackInput);
              setTotalStackInput(0);
            }}
          />
          <TimerControllerInputBox width="100%" height="34px" font="16px">
            <input
              value={totalStackInput ? totalStackInput.toLocaleString() : ""}
              type="text"
              inputMode="numeric"
              onChange={(e) => {
                const rawValue = e.target.value.replace(/[^0-9]/g, "");
                const value = parseInt(rawValue, 10) || 0;
                setTotalStackInput(value);
              }}
              placeholder="조절할 TOTAL STACK 입력"
            />
          </TimerControllerInputBox>
          <img
            src="/image-web/controller/plus.svg"
            alt="plus"
            onClick={() => {
              updateTotalStack(+totalStackInput);
              setTotalStackInput(0);
            }}
          />
        </MobileControllerInputWrapper>
      </MobileControllerBackgroundBox>
      <MobileControllerBackgroundBox>
        <div className="title">현재 플레이어 조정</div>
        <MobileControllerInputWrapper>
          <img
            src="/image-web/controller/minus.svg"
            alt="minus"
            onClick={() => handleUpdateUserCount(-1)}
          />
          <TimerControllerInputBox width="100%" height="32px" font="16px">
            <input
              value={userCountInput}
              type="text"
              inputMode="numeric"
              onChange={(e) => setUserCountInput(+e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleInputUserCount();
              }}
              onClick={(e) => e.currentTarget.select()}
            />
          </TimerControllerInputBox>
          <img
            src="/image-web/controller/plus.svg"
            alt="plus"
            onClick={() => handleUpdateUserCount(1)}
          />
        </MobileControllerInputWrapper>
      </MobileControllerBackgroundBox>
    </MobileTimerControllerClockWrapper>
  );
};

export default MobileTimerControllerClock;
